import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { fetchTeacherClassDetail } from '../../services/api';
import GroupsManager from '../../components/BreakoutRoomsManager';
import PageBackNavigation from '../../components/PageBackNavigation';

const S = {
  card: { background: 'white', borderRadius: 20, boxShadow: '0 4px 24px #0001', padding: '32px 36px', border: '1px solid #e0e7ef', maxWidth: 900, margin: '40px auto' },
  backBtn: { display: 'inline-flex', alignItems: 'center', gap: 6, background: '#eff6ff', color: '#2563eb', border: 'none', borderRadius: 8, padding: '8px 18px', fontWeight: 600, fontSize: 14, cursor: 'pointer', marginBottom: 24 },
  title: { fontSize: 24, fontWeight: 800, color: '#1e3a5f', marginBottom: 24 },
  groupGrid: { display: 'flex', flexWrap: 'wrap', gap: 24 },
  groupCard: groupColor => ({ border: `2px solid ${groupColor}`, borderRadius: 14, padding: 18, minWidth: 240, background: '#fff', boxShadow: '0 2px 8px #0001', marginBottom: 8, transition: 'box-shadow 0.15s, border-color 0.15s', cursor: 'pointer' }),
  groupName: groupColor => ({ fontWeight: 700, color: groupColor, fontSize: 18, marginBottom: 8 }),
  studentsLabel: { fontSize: 13, color: '#374151', fontWeight: 700 },
  studentList: { paddingLeft: 18, margin: '8px 0' },
  studentItem: { fontSize: 14, color: '#1e293b' },
  enterBtn: { background: '#2563eb', color: 'white', border: 'none', borderRadius: 8, padding: '8px 16px', fontWeight: 700, fontSize: 14, cursor: 'pointer', marginTop: 8 },
  noGroups: { color: '#6b7280', fontSize: 15, textAlign: 'center', margin: '40px 0' },
};

function ClassGroupsPage() {
  const { classId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  // Restore previous state if present
  const prevState = location.state || {};
  const [loading, setLoading] = useState<any>(true);
  const [error, setError] = useState<any>('');
  const [students, setStudents] = useState<any>([]);
  const [className, setClassName] = useState<any>('');

  useEffect(() => {
    setLoading(true);
    fetchTeacherClassDetail(classId)
      .then(data => {
        setClassName(data.class?.class_name || '');
        setStudents((data.students || []).map(student => ({ ...student, label: `${student.first_name || ''} ${student.last_name || ''}`.trim() || `ID:${student.student_id}` })));
      })
      .catch(() => setError('Could not load groups.'))
      .finally(() => setLoading(false));
  }, [classId]);

  if (loading) return <div style={{ padding: 24, color: '#6b7280', textAlign: 'center' }}>Loading...</div>;
  if (error) return <div style={{ padding: 24, color: '#dc2626', textAlign: 'center' }}>{error}</div>;

  const handleBack = () => {
    if (prevState && prevState.fromHome) {
      navigate('/teacher/home', { state: prevState.homeState });
      return;
    }

    navigate('/teacher/home');
  };

  return (
    <div style={S.card}>
      <PageBackNavigation onBack={handleBack} label="Back to teacher home" />
      <div style={S.title}>Groups for {className || `Class #${classId}`}</div>
      <GroupsManager classId={classId} students={students} />
      <PageBackNavigation onBack={handleBack} label="Back to teacher home" position="bottom" />
    </div>
  );
}

export default ClassGroupsPage;
